import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FavoriteData } from './types';
import { getMapsByFavoriteList } from './utils';

export function addFavoriteChannel(channelId: number) {
  return queryClient.setQueryData<FavoriteData>(queryKeys.favoriteChannels, (data) => {
    if (!data) {
      return;
    }

    const { favoriteList } = data;

    const favorite = {
      assetId: channelId,
      createDate: Math.floor(Date.now() / 1000),
    };

    const newList = [...favoriteList, favorite];

    const { dictionary, positions } = getMapsByFavoriteList(newList);

    return {
      favoriteDictionary: dictionary,
      favoritePositions: positions,
      favoriteList: newList,
    };
  });
}

export function deleteFavoriteChannel(channelId: number) {
  return queryClient.setQueryData<FavoriteData>(queryKeys.favoriteChannels, (data) => {
    if (!data) {
      return;
    }

    const { favoritePositions, favoriteList } = data;

    const position = favoritePositions.get(channelId);
    const newList = favoriteList.filter((_, index) => index !== position);

    const { dictionary, positions } = getMapsByFavoriteList(newList);

    return {
      favoriteDictionary: dictionary,
      favoriteList: newList,
      favoritePositions: positions,
    };
  });
}
